import React from 'react';

import DeleteRowIcon from 'assets/SvgIcon/DeleteRowIcon';

export default class ChartTagDeleteRenderer extends React.Component {
  clickHandler = () => this.props.context.tagDeleteHandler(this.props.node.data);

  render() {
    return <span onClick={this.clickHandler}> <DeleteRowIcon /> </span>;
  }
}
